import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { Auth } from 'aws-amplify'

import { Input } from 'antd'
import { Button } from 'antd'
import { message } from 'antd'

import { MailOutlined } from '@ant-design/icons'
import { LockOutlined } from '@ant-design/icons'
import {
  updateAuthData,
  LOGED_IN,
  LOGED_OUT,
  CHANGE_PASSWORD_CHALLENGE,
  EMAIL_VERIFICATION_CHALLENGE,
  RECOVERY_PASSWORD,
} from 'store/auth/auth'
import tychoLogo from 'assets/tycho-logo.png'
// import tychoLogoBlack from 'assets/tycho-logo-black.png'
import quadrantLogo from 'assets/logo-quadrant-blanco.png'
import electricTowers from 'assets/electric-towers.jpg'

import './login.css'

const Password = Input.Password

function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isLoggingIn, setIsLoggingIn] = useState(false)

  const dispatch = useDispatch()

  useEffect(() => {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        const groups = user.signInUserSession.accessToken.payload['cognito:groups']
        const emailVerified = user.signInUserSession.idToken.payload['email_verified']
        const email = user.signInUserSession.idToken.payload['email']
        const jwtToken = user.signInUserSession.accessToken['jwtToken']
        const isAuthenticated = true
        if (emailVerified) {
          Auth.currentSession().then((token) => {
            const jwtToken = token.getIdToken().getJwtToken()
            dispatch(
              updateAuthData({
                groups: groups,
                emailVerified: emailVerified,
                email: email,
                jwtToken: jwtToken,
                authStatus: LOGED_IN,
              }),
            )
          })
        } else {
          Auth.verifyCurrentUserAttribute('email').then(() => {
            Auth.currentSession().then((token) => {
              const jwtToken = token.getIdToken().getJwtToken()
              dispatch(
                updateAuthData({
                  groups: groups,
                  emailVerified: emailVerified,
                  email: email,
                  jwtToken: jwtToken,
                  authStatus: EMAIL_VERIFICATION_CHALLENGE,
                }),
              )
            })
          })
        }
      })
      .catch((err) => {
        updateAuthData({
          groups: [],
          emailVerified: false,
          email: '',
          jwtToken: '',
          authStatus: LOGED_OUT,
        })
      })
  })

  const loginSuccess = async (user) => {
    if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
      dispatch(
        updateAuthData({
          groups: [],
          emailVerified: false,
          email: email,
          jwtToken: '',
          authStatus: CHANGE_PASSWORD_CHALLENGE,
        }),
      )
    } else {
      const groups = user.signInUserSession.accessToken.payload['cognito:groups']
      const emailVerified = user.signInUserSession.idToken.payload['email_verified']
      const email = user.signInUserSession.idToken.payload['email']
      const isAuthenticated = true

      if (user.attributes.email_verified) {
        Auth.currentSession().then((token) => {
          const jwtToken = token.getIdToken().getJwtToken()
          dispatch(
            updateAuthData({
              groups: groups,
              emailVerified: emailVerified,
              email: email,
              jwtToken: jwtToken,
              authStatus: LOGED_IN,
            }),
          )
        })

        setEmail('')
        setPassword('')
        setIsLoggingIn(false)
      } else {
        Auth.verifyCurrentUserAttribute('email').then(() => {
          Auth.currentSession().then((token) => {
            const jwtToken = token.getIdToken().getJwtToken()
            dispatch(
              updateAuthData({
                groups: groups,
                emailVerified: emailVerified,
                email: email,
                jwtToken: jwtToken,
                authStatus: EMAIL_VERIFICATION_CHALLENGE,
              }),
            )
          })
        })
      }
    }
  }

  const userAndPasswordInvalid = (lbl) => {
    message.error(lbl)
    setEmail('')
    setPassword('')
    setIsLoggingIn(false)
  }

  const catchLoginError = (err) => {
    if (err.code === 'NotAuthorizedException') {
      // console.log('catchLoginError', err)
      userAndPasswordInvalid(err.message)
    } else {
      // eslint-disable-next-line
      console.log('catchLoginError', err)
      setIsLoggingIn(false)
    }
  }

  const submitLogin = () => {
    setIsLoggingIn(true)
    if (email) {
      if (password) {
        Auth.signIn(email, password.replace(/\s/g, ''))
          .then((user) => loginSuccess(user))
          .catch((err) => catchLoginError(err))
      } else {
        message.warning('Por favor, ingrese su contraseña')
        setIsLoggingIn(false)
      }
    } else {
      message.warning('Por favor, ingrese su correo')
      setIsLoggingIn(false)
    }
  }

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <img
        src={electricTowers}
        style={{
          marginLeft: 'auto',
          marginRight: 'auto',
          display: 'block',
          width: '60%',
          height: '100%',
          float: 'right',
        }}
      />
      <div
        style={{
          backgroundColor: '#313C40',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '40%',
        }}
      >
        {/*<div className='login-form-container'>*/}
        <div
          style={{
            width: '300px',
            position: 'absolute',
            top: '35%',
          }}
        >
          <img
            src={quadrantLogo}
            style={{
              marginLeft: 'auto',
              marginRight: 'auto',
              display: 'block',
              width: '300px',
              height: 'auto',
            }}
          />

          <div style={{ marginTop: '30px' }}>
            <Input
              onChange={(event) => setEmail(event.target.value)}
              disabled={isLoggingIn}
              prefix={<MailOutlined />}
              placeholder="Email"
              value={email}
            />
          </div>

          <div style={{ marginTop: '10px' }}>
            <Password
              onChange={(event) => setPassword(event.target.value)}
              disabled={isLoggingIn}
              prefix={<LockOutlined />}
              placeholder="Password"
              onPressEnter={submitLogin}
              value={password}
            />
          </div>

          <div style={{ marginTop: '10px', float: 'right', width: '100%', marginBottom: '10px' }}>
            <Button
              type="primary"
              onClick={submitLogin}
              disabled={isLoggingIn}
              style={{ marginTop: '10px', float: 'right', width: '100%' }}
            >
              Log in
            </Button>
          </div>
          <div>
            <a
              style={{ textAlign: 'right' }}
              onClick={() => {
                dispatch(
                  updateAuthData({
                    authStatus: RECOVERY_PASSWORD,
                    jwtToken: '',
                    email: '',
                    emailVerified: false,
                    groups: [],
                  }),
                )
              }}
            >
              Forgot password?
            </a>
          </div>
          {/*
          <div className='enoi-logo'>
            <img
              src={EnoiLogo}
            />
          </div>
          <div style={{display:'flex',justifyContent:'center',alignItems: 'center',marginTop:'15px',pointerEvents:'none'}}>
            <a style={{fontSize:'16px',color:'#808080'}}>In colaboration with:</a>
          </div>
          */}
        </div>
        <img
          style={{
            marginLeft: 'auto',
            marginRight: 'auto',
            display: 'flex',
            width: '300px',
            height: 'auto',
            marginTop: '90%',
          }}
          src={tychoLogo}
        />
      </div>
      {/*
      <div style={{
          marginLeft: 'auto',
          marginRight: 'auto',
          display: '',
          width: '60%',
          height: '100%',
          float: 'right',
          backgroundImage:`url(${electricTowers})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize:'cover'
        }}>
      </div>
      */}
    </div>
  )
}

export default Login
